import axios from "axios";
import { authHeader } from "src/utils/authHeader";

export const clientInstance = axios.create({
  baseURL: `${process.env.REACT_APP_CLIENT_API}/api`,
});

// Add a request interceptor
clientInstance.interceptors.request.use(async (config) => {
  const token = authHeader()

  if (token) config.headers.Authorization = `${token}`;

  return config;
});

// Add a response interceptor
// clientInstance.interceptors.response.use(
//   (response: AxiosResponse) => response,
//   (error) => {
//     // Handle 401 errors
//     if (error.response && error.response.status === 401) {
//       localStorage.clear();
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

export default clientInstance;
